/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { BeamAnalysisWorkResultDto } from './BeamAnalysisWorkResultDto';
import {
    instanceOfBeamAnalysisWorkResultDto,
    BeamAnalysisWorkResultDtoFromJSON,
    BeamAnalysisWorkResultDtoFromJSONTyped,
    BeamAnalysisWorkResultDtoToJSON,
} from './BeamAnalysisWorkResultDto';
import type { BeamConstancyWorkResultDto } from './BeamConstancyWorkResultDto';
import {
    instanceOfBeamConstancyWorkResultDto,
    BeamConstancyWorkResultDtoFromJSON,
    BeamConstancyWorkResultDtoFromJSONTyped,
    BeamConstancyWorkResultDtoToJSON,
} from './BeamConstancyWorkResultDto';
import type { ManualTaskWorkResultDto } from './ManualTaskWorkResultDto';
import {
    instanceOfManualTaskWorkResultDto,
    ManualTaskWorkResultDtoFromJSON,
    ManualTaskWorkResultDtoFromJSONTyped,
    ManualTaskWorkResultDtoToJSON,
} from './ManualTaskWorkResultDto';

/**
 * @type ResultDto
 * 
 * @export
 */
export type ResultDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.BeamConstancyWorkResultDto, Ptw.Ptw100.AppZero.Application.Shared' } & BeamConstancyWorkResultDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.ManualTaskWorkResultDto, Ptw.Ptw100.AppZero.Application.Shared' } & ManualTaskWorkResultDto | { $type?: 'Ptw.Ptw100.BeamAnalysis.Application.JobExecution.Dto.BeamAnalysisWorkResultDto, Ptw.Ptw100.BeamAnalysis.Application' } & BeamAnalysisWorkResultDto;


export function ResultDtoFromJSON(json: any): ResultDto {
    return ResultDtoFromJSONTyped(json, false);
}

export function ResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultDto {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.BeamConstancyWorkResultDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, BeamConstancyWorkResultDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.BeamConstancyWorkResultDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.ManualTaskWorkResultDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, ManualTaskWorkResultDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.ManualTaskWorkResultDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.BeamAnalysis.Application.JobExecution.Dto.BeamAnalysisWorkResultDto, Ptw.Ptw100.BeamAnalysis.Application':
            return Object.assign({}, BeamAnalysisWorkResultDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.BeamAnalysis.Application.JobExecution.Dto.BeamAnalysisWorkResultDto, Ptw.Ptw100.BeamAnalysis.Application' } as const);
        default:
            throw new Error(`No variant of ResultDto exists with '$type=${json['$type']}'`);
    }
}

export function ResultDtoToJSON(value?: ResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.BeamConstancyWorkResultDto, Ptw.Ptw100.AppZero.Application.Shared':
            return BeamConstancyWorkResultDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.ManualTaskWorkResultDto, Ptw.Ptw100.AppZero.Application.Shared':
            return ManualTaskWorkResultDtoToJSON(value);
        case 'Ptw.Ptw100.BeamAnalysis.Application.JobExecution.Dto.BeamAnalysisWorkResultDto, Ptw.Ptw100.BeamAnalysis.Application':
            return BeamAnalysisWorkResultDtoToJSON(value);
        default:
            throw new Error(`No variant of ResultDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the ResultDto interface.
 */
export function instanceOfResultDto(value: any): value is ResultDto {
    if (instanceOfBeamConstancyWorkResultDto(value)) return true;
    if (instanceOfManualTaskWorkResultDto(value)) return true;
    if (instanceOfBeamAnalysisWorkResultDto(value)) return true;
    return false;
}

